import React from "react";
import styles from "./ExpirySoonBottomSheet.module.scss";
import Button from "@src/components/UIElements/Button";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { directDeepLink } from "@src/common/deepLinks";

const ExpirySoonBottomSheet = ({
  mainText,
  detailText,
  showButton = true,
  subTextBelowBtn = true,

  dispatcher = false,
  onClose,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const isOpen = useSelector(
    (state) => state?.bottomSheetReducer?.showExpirySoonBottomSheet
  );
  const state = useSelector(
    (state) => state?.overViewReducer?.overViewDetails?.course
  );
  return (
    <Modal
      showModal={isOpen}
      handleClose={() => {
        if (onClose) {
          onClose();
        } else {
          dispatch(actionCreator.showExpirySoonBottomSheetAction(false));
        }
      }}
      header={mainText}
      blockBackdrop={true}
    >
      <div className={styles.ExpirySoonBottomSheet}>
        <div className={styles.ExpirySoonBottomSheet__image}>
          <Image
            src={getAwsAssets("clockIcon.svg", "bottomSheets")}
            width="74px"
            height="74px"
            alt={t(
              "components.bottomSheets.components.expirySoonBottomSheet.clockIcon",
              "ClockIcon"
            )}
          />
        </div>
        <h1 className={styles.ExpirySoonBottomSheet__heading}>
          {state?.expiryPopup?.heading || mainText}
        </h1>

        <p className={styles.ExpirySoonBottomSheet__subtext}>
          {state?.expiryPopup?.text || detailText}
        </p>

        {state?.expiryPopup?.cta1?.text ? (
          <Button
            onClick={() =>
              dispatch(actionCreator.showExpirySoonBottomSheetAction(false))
            }
          >
            {state?.expiryPopup?.cta1?.text}
          </Button>
        ) : null}

        {state?.expiryPopup?.cta2?.text ? (
          <p
            className={styles.ExpirySoonBottomSheet__viewAllInst}
            onClick={() =>
              directDeepLink(
                "",
                state?.expiryPopup?.cta2?.deeplink?.screen
              )(state?.expiryPopup?.cta2?.deeplink)
            }
          >
            {state?.expiryPopup?.cta2?.text}
          </p>
        ) : null}
      </div>
    </Modal>
  );
};

export default ExpirySoonBottomSheet;
